import queryString from 'query-string';

export const MonitorWizzardPaths = Object.freeze({
  addClient: 0,
  createClient: 1,
  emailReport: 2,
  addAccount: 3,
  importClient: 4,
  connectProfile: 5,
  monitor: 6,
  connectPreProfile: 7,
  connectPreProfileAlpha: 8,
  cases: 9,
  capitalReport: 10,
});

export const MonitorWizzardRedirectPaths = Object.freeze({
  [MonitorWizzardPaths.addClient]: 'monitor_add_client',
  [MonitorWizzardPaths.createClient]: 'monitor_create_client',
  [MonitorWizzardPaths.connectProfile]: 'profile',
  [MonitorWizzardPaths.connectPreProfile]: 'pre_profile',
  [MonitorWizzardPaths.connectPreProfileAlpha]: 'pre_profile_alpha',
  [MonitorWizzardPaths.monitor]: 'monitor',
  [MonitorWizzardPaths.cases]: 'direct',
  [MonitorWizzardPaths.capitalReport]: 'direct',
});

export const buildObjectMonitorWizzardRedirectUrl = ({
  baseUrl,
  fundingSearchId,
  objectId,
  context,
  integration,
}) =>
  Object.freeze({
    [MonitorWizzardPaths.addClient]: `${baseUrl}/monitor?${queryString.stringify({
      objectId,
      open: context,
      integration,
    })}`,
    [MonitorWizzardPaths.createClient]: `${baseUrl}/monitor?${queryString.stringify({
      objectId,
      open: context,
      integration,
    })}`,
    [MonitorWizzardPaths.connectProfile]: `${baseUrl}/funding/search/${fundingSearchId}/profile`,
    [MonitorWizzardPaths.connectPreProfile]: `${baseUrl}/funding/search/${fundingSearchId}/profile`,
    [MonitorWizzardPaths.connectPreProfileAlpha]: `${baseUrl}/funding/search/${fundingSearchId}/profile`,
    [MonitorWizzardPaths.monitor]: `${baseUrl}/monitor?${queryString.stringify({
      objectId,
      open: context,
      integration,
    })}`,
    [MonitorWizzardPaths.cases]: `${baseUrl}/cases`,
    [MonitorWizzardPaths.capitalReport]: `${baseUrl}/monitor?${queryString.stringify({
      capitalReport: objectId,
    })}`,
  });

export function isValid(type) {
  return Object.values(MonitorWizzardPaths).indexOf(type) >= 0;
}
